export const encodeSlash = (url: string) =>
    url.replace(/\//, '@SLASH@').replaceAll(/#/g, '@HASH@')
